import { NgModule } from "@angular/core";
import { CommonModule as AngularCommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "../common/common.module";
import { AuthModule } from "../auth/auth.module";
import { UtilModule } from "../util/util.module";
import { TourModule } from "../tour/tour.module";
import { KpiGroupComponent } from "./components/kpiGroup.component";
import { KpiGroupRowComponent } from "./components/kpiGroupRow.component";
import { KpiHostComponent } from "./components/kpiHost.component";
import { KpiHostMenuOptionComponent } from "./components/kpiHostMenuOption.component";
import { SingleDataComponent } from "./components/cardContents/singleData.component";
import { DualDataComponent } from "./components/cardContents/dualData.component";
import { ProgressBarComponent } from "./components/cardContents/progressBar.component";
import { StackedProgressBarComponent } from "./components/cardContents/stackedProgressBar.component";
import { MultiProgressComponent } from "./components/cardContents/multiProgress.component";
import { DoughnutChartComponent } from "./components/cardContents/doughnutChart.component";
import { BarChartComponent } from "./components/cardContents/barChart.component";
import { BarChartSummaryCounterComponent } from "./components/cardContents/barChartSummaryCounter.component";
import { BarChartSelectorLegendModifierComponent } from "./components/cardContents/barChartSelectorLegendModifier.component";
import { LineChartComponent } from "./components/cardContents/lineChart.component";
import { ChartDropdownComponent } from "./components/cardContents/chartDropdown.component";
import { DatatableComponent } from "./components/cardDetails/datatable.component";
import { DatatablePhoneCellComponent } from "./components/cardDetails/datatablePhoneCell.component";
import { DatatableActionCellComponent } from "./components/cardDetails/datatableActionCell.component";
import { TextFilterComponent } from "./components/cardDetails/textFilter.component";
import { DateFilterComponent } from "./components/cardDetails/dateFilter.component";
import { TextFilterOptionComponent } from "./components/cardDetails/textFilterOption.component";
import { NoDataComponent } from "./components/cardContents/noData.component";
import { DataErrorComponent } from "./components/cardContents/dataError.component";
import { SendSMSComponent } from "./components/cardDetails/sendSMS.component";
import { ActionResultComponent } from "./components/cardDetails/actionResult.component";
import { KpiTabContentComponent } from "./components/kpiTabContent.component";
import { TabRedirectorComponent } from "./components/tabRedirector.component";
import { DashboardMenuComponent } from "./dashboardMenu.component";
import { DashboardMobileMenuComponent } from "./dashboardMobileMenu.component";
import { AbsencesKpiServiceHostComponent } from "../dashboard/kpi/components/absencesKpi/absencesKpiServiceHost.component";
import { AbsencesService } from "../dashboard/kpi/services/absencesKpi/absences.service";
import { AbsencesDetailService } from "../dashboard/kpi/services/absencesKpi/absencesDetail.service";
import { AbsencesKpiCfgService } from "../dashboard/kpi/services/absencesKpi/absencesKpiCfg.service";

@NgModule({ exports: [
        KpiGroupComponent,
        KpiGroupRowComponent,
        KpiHostComponent,
        KpiHostMenuOptionComponent,
        SingleDataComponent,
        DualDataComponent,
        ProgressBarComponent,
        StackedProgressBarComponent,
        MultiProgressComponent,
        DoughnutChartComponent,
        BarChartComponent,
        BarChartSummaryCounterComponent,
        BarChartSelectorLegendModifierComponent,
        LineChartComponent,
        ChartDropdownComponent,
        DatatableComponent,
        DatatablePhoneCellComponent,
        DatatableActionCellComponent,
        TextFilterComponent,
        DateFilterComponent,
        TextFilterOptionComponent,
        NoDataComponent,
        DataErrorComponent,
        SendSMSComponent,
        ActionResultComponent,
        KpiTabContentComponent,
        TabRedirectorComponent,
        DashboardMenuComponent,
        DashboardMobileMenuComponent,
        //Common kpis
        AbsencesKpiServiceHostComponent
    ],
    declarations: [
        KpiGroupComponent,
        KpiGroupRowComponent,
        KpiHostComponent,
        KpiHostMenuOptionComponent,
        SingleDataComponent,
        DualDataComponent,
        ProgressBarComponent,
        StackedProgressBarComponent,
        MultiProgressComponent,
        DoughnutChartComponent,
        BarChartComponent,
        BarChartSummaryCounterComponent,
        BarChartSelectorLegendModifierComponent,
        LineChartComponent,
        ChartDropdownComponent,
        DatatableComponent,
        DatatablePhoneCellComponent,
        DatatableActionCellComponent,
        TextFilterComponent,
        DateFilterComponent,
        TextFilterOptionComponent,
        NoDataComponent,
        DataErrorComponent,
        SendSMSComponent,
        ActionResultComponent,
        KpiTabContentComponent,
        TabRedirectorComponent,
        DashboardMenuComponent,
        DashboardMobileMenuComponent,
        //Common Kpis
        AbsencesKpiServiceHostComponent
    ], imports: [AngularCommonModule,
        CommonModule,
        AuthModule,
        UtilModule,
        NgbModule,
        FormsModule,
        TourModule], providers: [
        AbsencesKpiCfgService,
        AbsencesService,
        AbsencesDetailService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class DashboardCommonModule {

}
